export default {
    realtyType: 'Тип недвижимости',
};
